export default "__VITE_PUBLIC_ASSET__c53f4c83__"